import { Location } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  LocalizeParser,
  LocalizeRouterModule,
  LocalizeRouterSettings,
  ManualParserLoader,
} from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';

import { NotFoundComponent } from './attendee/components/shared/not-found/not-found.component';
import { AuthModule } from './auth/auth.module';
import { configuredLang } from './i18n/i18n.module';

const routes: Routes = [
  // Routes without localization
  {
    path: 'auth',
    loadChildren: () => AuthModule,
    data: { skipRouteLocalization: true },
  },
  {
    path: '',
    loadChildren: () => import('./cms/cms.module').then((m) => m.CmsModule),
    data: { skipRouteLocalization: true },
  },
  {
    path: '',
    loadChildren: () =>
      import('./widget/widget.module').then((m) => m.WidgetModule),
    data: { discriminantPathKey: 'WIDGET' },
  },
  // Routes with localization
  // Keep homepage in first
  {
    path: '',
    loadChildren: () =>
      import('./attendee/attendee.module').then((m) => m.AttendeeModule),
    data: { discriminantPathKey: 'ATTENDEE' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./checkout/checkout.module').then((m) => m.CheckoutModule),
    data: { discriminantPathKey: 'CHECKOUT' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./organizer/organizer.module').then((m) => m.OrganizerModule),
    data: { discriminantPathKey: 'ORGANIZER' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./organizer/qr-code-validation/qr-code-validation.module').then(
        (m) => m.QrCodeValidationModule
      ),
    data: { discriminantPathKey: 'QRCODE' },
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

/**
 * Prefix route of the sub modules
 */
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      initialNavigation: 'disabled',
      scrollPositionRestoration: 'disabled',
    }),
    LocalizeRouterModule.forRoot(routes, {
      initialNavigation: true,
      parser: {
        provide: LocalizeParser,
        useFactory: (
          translate: TranslateService,
          location: Location,
          settings: LocalizeRouterSettings
        ) =>
          new ManualParserLoader(
            translate,
            location,
            { ...settings, useCachedLang: true },
            configuredLang,
            'ROUTES.'
          ),
        deps: [TranslateService, Location, LocalizeRouterSettings],
      },
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
